import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  flex: '0 0 50px',
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  padding: 0 30px;
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  background-color: #f9f9f9;
  position: sticky;
  top: 0;
  z-index: 11;

  @media print {
    display: none;
  }
`;

export const WorkoutDescription = styled(Flex)`
  flex: 0 0 auto;
  padding: 0 30px;
  width: 100%;
  min-height: 260px;

  @media print {
    flex: 0 0 auto;
    width: 86%;
    margin: 0 auto;
  }
`;

export const ExerciseListWrapper = styled(Flex)`
  width: 100%;
  padding: 0 30px 20px 30px;

  @media print {
    padding: 0;
  }
`;
